<template>
  <div class="add-status">
    <div class="input-group">
      <input
        type="text"
        ref="input"
        v-model="name"
        @keyup.enter.stop="accept"
        :placeholder="$tr('settings.statuses.newStatusName')"
      >
      <button class="accept" @click="accept"></button>
      <span class="counter"> {{ name.length }}/{{ MAX_LENGTH_NAME }}</span>
    </div>
    <vbutton class="cancel"
      color="grey"
      label="settings.statuses.cancel"
      @click="cancel" />
  </div>
</template>

<script>
const MAX_LENGTH_NAME = 36

export default {
  name: 'add-or-edit-status',

  props: {
    initialName: {
      type: String,
      default: ''
    },

    callbackWithName: {
      type: Function,
      required: true
    }
  },

  watch: {
    name (val) {
      if (val.length > MAX_LENGTH_NAME) {
        this.name = val.slice(0, MAX_LENGTH_NAME)
      }
    }
  },

  data () {
    return {
      name: this.initialName,
      MAX_LENGTH_NAME: MAX_LENGTH_NAME
    }
  },

  methods: {
    accept () {
      this.callbackWithName(this.name)
      this.$emit('close')
    },

    cancel () {
      this.$emit('close')
    }
  },

  mounted () {
    this.$refs.input.focus()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.add-status {
  width: 50%;
  padding: 10px 20px 10px 10px;
  background: #f1f2f2;
  border-bottom: 1px solid #dddddd;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  min-width: 500px;

  .input-group {
    display: flex;
    position: relative;
    width: 75%;
    max-width: 470px;
  }

  input {
    font-size: 16px;
    padding: 10px 55px 10px 15px;
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 2px 0 0 2px;
    color: $text-color;
    width: 100%;
    border-right-width: 0;
  }

  .counter {
    position: absolute;
    right: 45px;
    line-height: 40px;
    color: #a8a8a8;
  }

  button {
    border: none;

    &:hover {
      cursor: pointer;
    }
  }

  .accept {
    height: 40px;
    width: 40px;
    min-width: 40px;
    background-color: $green;
    background-image: url('/static/images/elements/trigger_on.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15px;
    border-radius: 0 2px 2px 0;
  }

  .cancel {
    margin-left: 20px;
    background: transparent;
  }
}
</style>
